import { RegisteredReducer, reducer } from '@ardoq/rxbeach';
import {
  loadStoredQuery,
  resetAllSearchState,
  resetSharedSearchState,
} from 'search/actions';
import {
  advancedSearchError,
  exportAdvancedSearch,
  exportAdvancedSearchSuccess,
  queryAdvancedSearch,
  queryAdvancedSearchSuccess,
  selectCondition,
  selectFields,
  selectFilterType,
  selectPage,
  selectSnapshot,
  updateAdvancedSearch,
} from './actions';
import { advancedSearchOperations } from './advancedSearchOperations';
import { AdvancedSearchStateShape } from './types';

export const reducers: RegisteredReducer<AdvancedSearchStateShape>[] = [
  reducer(
    updateAdvancedSearch,
    advancedSearchOperations.updateAdvancedSearchReducer
  ),
  reducer(selectCondition, advancedSearchOperations.selectConditionReducer),
  reducer(selectFilterType, advancedSearchOperations.selectFilterTypeReducer),
  reducer(
    queryAdvancedSearchSuccess,
    advancedSearchOperations.queryAdvancedSearchSuccessReducer
  ),
  reducer(
    advancedSearchError,
    advancedSearchOperations.advancedSearchErrorReducer
  ),
  reducer(
    queryAdvancedSearch,
    advancedSearchOperations.queryAdvancedSearchReducer
  ),
  reducer(
    resetAllSearchState,
    advancedSearchOperations.resetAllSearchStateReducer
  ),
  reducer(
    resetSharedSearchState,
    advancedSearchOperations.resetAllSearchStateReducer
  ),
  reducer(selectPage, advancedSearchOperations.selectPageReducer),
  reducer(selectSnapshot, advancedSearchOperations.selectSnapshotReducer),
  reducer(selectFields, advancedSearchOperations.selectFieldsReducer),
  reducer(
    exportAdvancedSearch,
    advancedSearchOperations.exportAdvancedSearchReducer
  ),
  reducer(
    exportAdvancedSearchSuccess,
    advancedSearchOperations.exportAdvancedSearchSuccessReducer
  ),
  reducer(loadStoredQuery, advancedSearchOperations.loadStoredQueryReducer),
];
